const testValueType = (v) => (type) => type.test(v);
export {
  testValueType
};
